// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"c49c56d9","425":"9d181a43","499":"10afc18a","527":"2271dda0","540":"dc1c5c31","541":"35dafe75","648":"d1253142","878":"01fd7e02","929":"1fd65c07","961":"ce4ec849"}[chunkId] + ".chunk.js";
};